import reloadApi from '@/api/reloadApi';
import ActionButton from '@/components/actions/actionButton';
import { Checkbox, Stack } from '@mantine/core';
import { modals } from '@mantine/modals';
import { type ReloadType, reloadTypes } from 'lib/models/reloadRequest';
import { useState } from 'react';

const labels: Record<ReloadType, { label: string; description: string }> = {
  definitions: { label: 'Index definitions', description: 'Pull the definitions repository' },
  collections: { label: 'Databases and indexes', description: 'List databases, collections and their indexes' },
  storageStats: { label: 'Storage stats', description: 'Document counts and sizes - includes databases and indexes' },
  queryStats: { label: 'Query shapes', description: 'Query shapes, plan cache and winning plans of every node' },
  slowQueries: { label: 'Slow queries', description: 'Slow query log of every node' },
};

export default function ReloadDialog() {
  const [types, setTypes] = useState<ReloadType[]>([...reloadTypes]);

  async function reload() {
    await reloadApi.reload(types);
    modals.closeAll();
  }

  return (
    <Stack>
      <Checkbox.Group value={types} onChange={(value) => setTypes(value as ReloadType[])}>
        <Stack gap="xs">
          {reloadTypes.map((type) => (
            <Checkbox key={type} value={type} label={labels[type].label} description={labels[type].description} />
          ))}
        </Stack>
      </Checkbox.Group>

      <ActionButton onClick={reload} disabled={types.length === 0 || undefined}>
        Reload
      </ActionButton>
    </Stack>
  );
}
